import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import { getDefaultCancelationReason } from 'AppSrc/core/crq/crq-status-reasons';
// import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
// import {
//   updateEditCrqWithId,
// } from 'AppSrc/core/actions/actions-update-edit-form';
import {
  getBackwardTransition,
} from 'AppSrc/core/crq/crq-status-transitions';
import {
  clearEditSectionsRead,
  fetchCrqForViewEdit,
} from 'AppSrc/core/actions/actions-edit-form';
// import { fetchCrqForViewEdit } from 'AppSrc/core/actions/actions-edit-form';
import { ES_VIEWING_NEW_SECTION } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { Alert } from 'AppSrc/core/components/utility/alert';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { currentSelectedNetwork } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { CancelCrqActionsModal } from 'AppSrc/core/components/view-crq-screen/modals/cancel-crq-actions-modal';
import { submitAndCancelCreateCrqForm } from 'AppSrc/core/actions/actions-create-crq-form';


class ExitFormButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      exitText: 'Exit without saving',
      exitAlertText: 'Are you sure you want to exit CRQ without saving it?',
      showCancel: false,
      cancelCrqModelOpen: false,
    };
    this.preNavigateAlert = this.preNavigateAlert.bind(this);
    this.resolveAlert = this.resolveAlert.bind(this);
    this.openCancelModel = this.openCancelModel.bind(this);
    this.cancelCrqStatus = this.cancelCrqStatus.bind(this);
  }

  preNavigateAlert() {
    this.setState({
      showAlert: true,
    });
  }

  resolveAlert(params) {
    const {
      history,
      deleteAllDataForForm,
      formId,
    } = this.props;
    const {
      boolean,
    } = params;

    this.setState({
      showAlert: false,
    });

    if (boolean === false) {
      return null;
    }
    history.push('/');
    deleteAllDataForForm(formId);
    return null;
  }

  openCancelModel() {
    this.setState({
      cancelCrqModelOpen: true,
    });
  }

  cancelCrqStatus() {
    const {
      rejectToPrevStatus,
      currentNetwork,
    } = this.props;
    rejectToPrevStatus(currentNetwork)
      .catch((error) => {
        console.error(error);
        // errorAlert({
        //   errorTitle: 'Failed update CRQ',
        //   errorText: 'Sorry we are unable to update your CRQ due to a technical issue. Please try again later.',
        // });
      });
  }


  render() {

    const {
      showAlert,
      exitText,
      exitAlertText,
      showCancel,
      cancelCrqModelOpen,
    } = this.state;
    const {
      sectionIndex,
      formData,
      // currentNetwork,
      crqId,
    } = this.props;
    const hasCrqId = crqId ? true : false;
    const network = currentSelectedNetwork(formData);
    // Only Coordinator should see the Save and Exit option for below network stages once the CRQ ID is created.
    if (hasCrqId && network === 'fixed' && ((sectionIndex === 4) || (sectionIndex === 5) || (sectionIndex === 6) || (sectionIndex === 7))) {
      this.setState({
        exitText: 'Save and Exit',
        exitAlertText: 'Are you sure you want to Save and Exit?',
        showCancel: true,
      });
    }
    else if (hasCrqId && network === 'mobile' && ((sectionIndex === 5) || (sectionIndex === 6))) {
      this.setState({
        exitText: 'Save and Exit',
        exitAlertText: 'Are you sure you want to Save and Exit?',
        showCancel: true,
      });
    }
    else if (network === 'OLO' && ((sectionIndex === 4) || (sectionIndex === 5) || (sectionIndex === 6))) {
      this.setState({
        exitText: 'Save and Exit',
        exitAlertText: 'Are you sure you want to Save and Exit?',
        showCancel: true,
      });
    }
    const alertData = {
      option: null,
      alertTitle: exitAlertText,
      trueText: 'Yes',
      falseText: 'No',
    };

    return (
      <>
        <div className="exit-wrapper">
          {showCancel === true && (
            <div className="cancel-crq-wrap">
              <button type="button" className="cancel-crq-btn" onClick={this.openCancelModel}><p>Cancel CRQ</p></button>
            </div>
          )}
          {cancelCrqModelOpen && (
            <CancelCrqActionsModal
              closeModal={() => this.setState({ cancelCrqModelOpen: false })}
              network={network}
              cancelCrqStatus={this.cancelCrqStatus}
              crqId={crqId}
            />
          )}
          <button
            type="button"
            className="exit-form"
            onClick={this.preNavigateAlert}
          >
            <p>
              {exitText}
            </p>
          </button>
          {
            showAlert && (
              <Alert
                alertData={alertData}
                resolveAlert={this.resolveAlert}
              />
            )
          }
        </div>
      </>
    );
  }
}

ExitFormButton.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  formId: PropTypes.string,
  deleteAllDataForForm: PropTypes.func,
  formData: formDataShape,
  sectionIndex: PropTypes.number,
  rejectToPrevStatus: PropTypes.func,
  currentNetwork: PropTypes.string,
  crqId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const { crqId } = ownProps;
  const formData = state.mainForm.formData['create-crq'];
  const currentNetwork = formData ? currentSelectedNetwork(formData) : null;
  console.log('map state data>>', crqId);
  return { currentNetwork };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
  rejectToPrevStatus: (currentNetwork) => {
    const {
      crqId,
      // currentNetwork,
      deleteAllDataForForm,
      formId,
    } = ownProps;
    // This function is responsible to cancel crq with submitAndCancelCreateCrqForm
    const statusTransition = getBackwardTransition({ currentStatus: '3' });
    const selectedReason = getDefaultCancelationReason(currentNetwork);
    return dispatch(submitAndCancelCreateCrqForm(statusTransition, selectedReason))
      .then(() => {
        const network = currentNetwork;
        dispatch(clearEditSectionsRead(crqId));
        dispatch(fetchCrqForViewEdit({
          editingStatus: ES_VIEWING_NEW_SECTION,
          crqId,
          network,
        }));
        // navigate to the success route, with the correct crqId
        // const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
        //   network,
        //   crqId,
        //   transitionId: statusTransition.id,
        // });
        // ownProps.history.push(successPath);
        ownProps.history.push('/');
        deleteAllDataForForm(formId);
        // window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        // TODO add error alert
      });
  },
});

const ExitFormButtonDisplay = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExitFormButton));

export {
  ExitFormButtonDisplay,
};
